// @flow

import AppDispatcher from 'PMT/flux/AppDispatcher';
import PMTApiPayment from 'PMT/api/ApiPayment';

import SessionStore from 'stores/SessionStore';

import ActionTypes from 'constants/ActionTypes';

import PaymentStatistics from 'PMT/entities/PaymentStatistics';
import ApiError from 'PMT/entities/ApiError';
import Timelapse from 'PMT/entities/Timelapse';
import PayinList from 'PMT/entities/PayinList';
import PayoutList from 'PMT/entities/PayoutList';
import PaymentsList from 'PMT/entities/PaymentsList';

export default class PaymentAction {

  // -- statistics
  static loadStatistics(timelapse: Timelapse) {
    PMTApiPayment.getStatistics(
      SessionStore.getRestaurantId(),
      timelapse.getFromTimeAsMilliseconds(),
      timelapse.getToTimeAsMilliseconds(),
      PaymentAction.receivePaymentStatistics,
      PaymentAction.receivePaymentStatisticsError,
    );
  }

  static receivePaymentStatistics(paymentStatistics: PaymentStatistics) {
    AppDispatcher.handleViewAction({
      type: ActionTypes.PAYMENT_STATISTICS_RESPONSE_SUCCESS,
      paymentStatistics
    });
  }

  static receivePaymentStatisticsError(apiError: ApiError) {
    AppDispatcher.handleViewAction({
      type: ActionTypes.PAYMENT_STATISTICS_RESPONSE_FAILURE,
      apiError
    });
  }

  //
  // payins
  //

  static loadPayins(timelapse: Timelapse) {
    AppDispatcher.handleServerAction({
      type: ActionTypes.PAYMENT_PAYINS_RESPONSE_REQUEST
    });

    PMTApiPayment.getPayins(
      SessionStore.getRestaurantId(),
      timelapse.getFromTimeAsMilliseconds(),
      timelapse.getToTimeAsMilliseconds(),
      PaymentAction.receivePayinsList,
      PaymentAction.receivePayinsListError,
    );
  }

  static receivePayinsList(payinList: PayinList) {
    AppDispatcher.handleViewAction({
      type: ActionTypes.PAYMENT_PAYINS_RESPONSE_SUCCESS,
      payinList
    });
  }

  static receivePayinsListError(apiError: ApiError) {
    AppDispatcher.handleViewAction({
      type: ActionTypes.PAYMENT_PAYINS_RESPONSE_FAILURE,
      apiError
    });
  }

  //
  // payouts
  //

  static loadPayouts(timelapse: Timelapse) {
    AppDispatcher.handleServerAction({
      type: ActionTypes.PAYMENT_PAYOUTS_RESPONSE_REQUEST
    });

    PMTApiPayment.getPayouts(
      SessionStore.getRestaurantId(),
      timelapse.getFromTimeAsMilliseconds(),
      timelapse.getToTimeAsMilliseconds(),
      PaymentAction.receivePayoutsList,
      PaymentAction.receivePayoutsListError,
    );
  }

  static receivePayoutsList(payoutList: PayoutList) {
    AppDispatcher.handleViewAction({
      type: ActionTypes.PAYMENT_PAYOUTS_RESPONSE_SUCCESS,
      payoutList
    });
  }

  static receivePayoutsListError(apiError: ApiError) {
    AppDispatcher.handleViewAction({
      type: ActionTypes.PAYMENT_STATISTICS_RESPONSE_FAILURE,
      apiError
    });
  }

  //
  // user payments
  //

  static loadUserPayments(timelapse: Timelapse, userId: string) {
    PMTApiPayment.getUserPaymentsForRestaurant(
      SessionStore.getRestaurantId(),
      timelapse.getFromTimeAsMilliseconds(),
      timelapse.getToTimeAsMilliseconds(),
      userId,
      PaymentAction.receiveUserPaymentsList,
      PaymentAction.receiveUserPaymentsListError,
    );
  }

  static receiveUserPaymentsList(paymentsList: PaymentsList) {
    AppDispatcher.handleViewAction({
      type: ActionTypes.GET_USER_PAYMENTS_RESPONSE_SUCCESS,
      paymentsList
    });
  }

  static receiveUserPaymentsListError(apiError: ApiError) {
    AppDispatcher.handleViewAction({
      type: ActionTypes.GET_USER_PAYMENTS_RESPONSE_FAILURE,
      apiError
    });
  }

}



// WEBPACK FOOTER //
// ./scripts/actions/PaymentAction.js